export default __webpack_public_path__ + "static/media/welcome.1a9cd2f8.png";